import React, {useState} from "react"
import Trigger from 'rc-trigger';
import "rc-trigger/assets/index.css"
import "./index.css"

const Popconfirm = (props) => {
    let {children, title, onConfirm} = props;
    let [visible, setVisible] = useState(false)
    const onSubmit = () => {
        setVisible(false)
        onConfirm()
    }
    return (
        <Trigger
            popupVisible={visible}
            onPopupVisibleChange={() => {
                setVisible(true)
            }}
            action={['click']}
            popup={
                <div className={'confirmModal'}>
                    {/*<div className={'popover-arrow'}></div>*/}
                    <div>
                        {title}
                    </div>
                    <div className={'btn-box'}>
                        <button type="button" className="btn white-btn btn-xs"
                                onClick={() => {
                                    setVisible(false)
                                }}
                        ><span>No</span></button>
                        {' '}
                        <button type="button" className="btn btn-success btn-xs" onClick={() => {
                            onSubmit()
                        }}><span>Yes</span>
                        </button>
                    </div>
                </div>
            }
            popupAlign={{
                points: ['bc', 'tc'],
                offset: [-109, -25]
            }}
            alignPoint
            destroyPopupOnHide
            maskClosable
        >
            {children}
        </Trigger>
    )
}
export default Popconfirm
